export const EXCLUDED_CATEGORIES = ["20000450150", "80000573", "6000074"];
export const EXCLUDED_PRODUCT_ID = "112404651";
export const EXCLUDED_PRODUCT_TYPE = "CompositeBundle";
export const EXCLUDED_BRANDS = [
  "nespresso",
  "kuoni",
  "benugo",
  "jo malone",
  "le labo",
  "longchamp",
  "mac",
  "monica vinader",
  "coach",
  "trinny london",
];
